//      
import { useRef, useEffect } from 'react';

export default function usePrevious   (current   )                   {
  const ref = useRef   (current);

  // will be updated on the next render
  useEffect(() => {
    ref.current = current;
  });

  // return the existing current (pre render)
  return ref;
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-previous-ref.js